(() => {
  const WIDGET_SELECTOR = '.rebuy-widget.widget-type-product-addon';
  const BLOCK_MOUNT_SELECTOR = '.rebuy-product-addon-block__widget';
  const PAGEFLY_ANCHOR_SELECTOR = '[data-rebuy-pagefly-anchor]';
  const GLOBAL_MOUNT_SELECTOR = '.rebuy-pdp-global-mount';
  const HIDDEN_PARENT_SELECTOR =
    '.product-form-block[data-update-id*="price"]:not([data-update-id*="terms"]), .product-payment-terms-block, .rebuy-pdp-global-mount';
  const REBUY_EVENTS = ['rebuy:ready', 'rebuy.ready', 'rebuy:widget.ready', 'rebuy.widget.ready'];
  const PAGEFLY_ATC_SELECTORS = [
    '.pf-product-form button[data-product-id]',
    'form.pf-product-form [data-pf-type="ProductATC"]',
    'form.pf-product-form button[type="submit"]',
  ];

  function initRebuyWidgets() {
    if (!window.Rebuy) return;

    if (typeof window.Rebuy.init === 'function') {
      window.Rebuy.init();
      return;
    }

    if (!Array.isArray(window.Rebuy.widgets)) return;

    document.querySelectorAll('[data-rebuy-addon-block] [data-rebuy-id], .rebuy-pdp-global-mount [data-rebuy-id]').forEach((mount) => {
      const widgetId = mount.getAttribute('data-rebuy-id');
      const widget = window.Rebuy.widgets.find((entry) => String(entry.id) === String(widgetId));

      if (widget && typeof widget.getWidgetProducts === 'function') {
        widget.getWidgetProducts();
      }
    });
  }

  function getBlockMounts() {
    return document.querySelectorAll(BLOCK_MOUNT_SELECTOR);
  }

  function isHiddenPlacement(node) {
    return Boolean(node?.closest(HIDDEN_PARENT_SELECTOR));
  }

  function getPageFlyAnchor() {
    const pageflyAnchor = document.querySelector(`${PAGEFLY_ANCHOR_SELECTOR} ${BLOCK_MOUNT_SELECTOR}`);
    if (!pageflyAnchor) return null;

    const searchRoots = [
      document.querySelector('#__pf'),
      document.querySelector('[data-pf-type="ProductBox"]')?.closest('form.pf-product-form'),
      document.querySelector('form.pf-product-form'),
    ].filter(Boolean);

    for (const root of searchRoots) {
      for (const selector of PAGEFLY_ATC_SELECTORS) {
        const addToCart = root.querySelector(selector);
        if (!addToCart) continue;

        const form = addToCart.closest('.pf-product-form');
        if (!form) continue;

        let slot = form.querySelector('.rebuy-pagefly-slot');
        if (!slot) {
          slot = document.createElement('div');
          slot.className = 'rebuy-pagefly-slot';
          addToCart.insertAdjacentElement('afterend', slot);
        }

        return slot;
      }
    }

    return pageflyAnchor;
  }

  function getTargetMount(mount) {
    const pageflyTarget = mount.closest(PAGEFLY_ANCHOR_SELECTOR) ? getPageFlyAnchor() : null;
    return pageflyTarget || mount;
  }

  function relocateMisplacedWidgets() {
    const mounts = getBlockMounts();
    if (!mounts.length) return false;

    let moved = false;

    mounts.forEach((mount) => {
      const targetMount = getTargetMount(mount);
      const hasWidgetInTarget = Boolean(targetMount.querySelector(WIDGET_SELECTOR));

      if (!hasWidgetInTarget) {
        const misplacedWidgets = Array.from(document.querySelectorAll(WIDGET_SELECTOR)).filter(
          (widget) => !targetMount.contains(widget) && (isHiddenPlacement(widget) || mount.contains(widget) === false)
        );

        misplacedWidgets.forEach((widget) => {
          targetMount.appendChild(widget);
          widget.style.removeProperty('display');
          widget.style.removeProperty('visibility');
          moved = true;
        });
      }

      if (targetMount !== mount && mount.querySelector(WIDGET_SELECTOR)) {
        Array.from(mount.querySelectorAll(WIDGET_SELECTOR)).forEach((widget) => {
          targetMount.appendChild(widget);
          widget.style.removeProperty('display');
          widget.style.removeProperty('visibility');
          moved = true;
        });
      }
    });

    return moved;
  }

  function refreshRebuyAddons() {
    const moved = relocateMisplacedWidgets();
    const hasWidget = Boolean(document.querySelector(`${BLOCK_MOUNT_SELECTOR} ${WIDGET_SELECTOR}, .rebuy-pagefly-slot ${WIDGET_SELECTOR}`));

    if (moved || !hasWidget) {
      initRebuyWidgets();
    }
  }

  function bindEvents() {
    REBUY_EVENTS.forEach((eventName) => {
      document.addEventListener(eventName, refreshRebuyAddons);
    });

    window.addEventListener('load', refreshRebuyAddons);

    if (window.eventBus && typeof window.eventBus.on === 'function') {
      window.eventBus.on('variant:updated', refreshRebuyAddons);
    }

    document.addEventListener('change', (event) => {
      if (event.target?.matches?.('.pf-variant-select, [name="id"]')) {
        refreshRebuyAddons();
      }
    });

    let attempts = 0;
    const poll = window.setInterval(() => {
      attempts += 1;
      refreshRebuyAddons();

      const hasWidget = Boolean(document.querySelector(`${WIDGET_SELECTOR}`));
      if (hasWidget || attempts >= 40) {
        window.clearInterval(poll);
      }
    }, 250);
  }

  function init() {
    refreshRebuyAddons();
    bindEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
